import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "home" }

import { computed } from 'vue'

const appVersion: string = '1.0.1';


export default /*@__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const isLocalhost = computed(() => {
  return window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[2] || (_cache[2] = _createElementVNode("h1", null, "Greenstep Hub Microservices", -1)),
    _cache[3] || (_cache[3] = _createElementVNode("p", null, "This is a purchase invoice approval application", -1)),
    _createElementVNode("p", { class: "version" }, "Version: " + _toDisplayString(appVersion)),
    (isLocalhost.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _cache[0] || (_cache[0] = _createElementVNode("h2", null, "Test instructions", -1)),
          _cache[1] || (_cache[1] = _createElementVNode("p", null, [
            _createTextVNode("To test this application, please go to "),
            _createElementVNode("a", { href: "/demotoken" }, "Token generator page")
          ], -1))
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})